module.exports = __webpack_public_path__ + "img/2025-06-11a_3.cc376906.jpg";